import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { useListVals } from 'react-firebase-hooks/database'
import { NotificationDb } from '../../firebaseConfig'
import { useHistory } from 'react-router-dom'
import { SIZES } from '../../styles/theme'
import TimeAgo from 'javascript-time-ago'
import ReactTimeAgo from 'react-time-ago'
import enMY from 'javascript-time-ago/locale/en-MY'
import { Loader } from '../shared/Loader'
import { fixedAssets } from 'src/containers/PreCache'
import notificationWorld from 'src/images/ntc/notifications/world-map.webp'
import notificationCity from 'src/images/ntc/notifications/cityscape.webp'
import closeCircleIcon from 'src/images/ntc/notifications/close-circle.svg'
import chevronRightIcon from 'src/images/ntc/notifications/chevron-right.svg'

TimeAgo.addDefaultLocale(enMY)

const StyledModal = styled(Modal)`
  text-align: left;

  .modal-dialog {
    width: 90%;
    max-width: none;
    min-height: 100vh;
    margin: 0 0 0 auto;
  }

  .modal-content {
    height: 100vh;
    min-height: 100vh;
    padding: 0;
    overflow: visible;
    border: 0;
    border-radius: 0;
    color: #fff;
    background: rgba(255, 255, 255, 0.5);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
  }

  .modal-header {
    display: none;
  }

  .desktop-close-modal {
    position: absolute;
    top: 50%;
    left: -28px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    padding: 8px;
    border: 0;
    border-radius: 10px;
    background: var(--Gold-Gradient-01);
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    transform: translateY(-50%);

    img {
      width: 13px;
      height: 24px;
    }
  }

  .desktop-notification-banner {
    position: relative;
    flex: 0 0 220px;
    width: 100%;
    height: 220px;
    overflow: hidden;
    background: url(${fixedAssets.speakerHeader}) center / cover no-repeat;
  }

  .desktop-modal-title {
    flex: 0 0 auto;
    margin: 40px 0 0;
    color: #fff;
    font-family: 'Din', sans-serif;
    font-size: 48px;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    text-shadow: 0 1px 7px var(--modal-accent);
    text-transform: uppercase;
  }

  .notification-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin: 0;
  }

  .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 40px;
    padding: 30px 100px 52px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  #refresh-btn {
    border: 0;
    background: var(--Gold-Gradient-01);
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    color: #fff;
    padding: 5px 10px;
    border-radius: 10px;
    margin: 36px auto;
    display: block;
    font-family: 'Din', 'DIN', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
  }

  .mobile-modal-close {
    display: none;
  }

  ${SIZES.mobile} {
    .modal-dialog {
      width: 100%;
      max-width: 100%;
      min-height: 100vh;
      min-height: 100dvh;
      margin: 0;
    }

    .modal-content {
      width: 100%;
      height: 100vh;
      height: 100dvh;
      min-height: 100vh;
      min-height: 100dvh;
      margin: 0;
      padding: 0;
      overflow: hidden;
      color: #fff;
      background: transparent;
      -webkit-backdrop-filter: none;
      backdrop-filter: none;

      .modal-header {
        display: flex;
        flex: 0 0 100px;
        align-items: flex-end;
        justify-content: space-between;
        height: 100px;
        padding: 64px 20px 0;
        border: 0;

        .modal-title {
          color: #fff;
          font-family: 'Din', sans-serif;
          font-size: 30px;
          font-weight: 700;
          line-height: 1;
        }

        button.close {
          display: none;
        }
      }
    }

    .desktop-close-modal,
    .desktop-notification-banner,
    .desktop-modal-title {
      display: none;
    }

    .mobile-modal-close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      color: #fff;
      background: transparent;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .modal-body {
      margin-top: 0;
      padding: 24px 20px 20px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .notification-list {
      gap: 10px;
    }
  }
`

const MessageWrapper = styled.div`
  position: relative;
  isolation: isolate;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(32px, 12.34vw, 237px);
  width: 100%;
  min-height: 109px;
  padding: 20px;
  overflow: hidden;
  background-image: url(${notificationWorld}), linear-gradient(109.453deg, #fff 39.792%, #ffeebd 114.59%);
  background-repeat: no-repeat;
  background-position: left 35.82% top -39.71%, center;
  background-size: 51.6% 271%, cover;
  box-shadow: 0 4px 13px rgba(0, 0, 0, 0.26);

  &::after {
    position: absolute;
    inset: 0;
    z-index: 0;
    content: '';
    background-image: url(${notificationCity});
    background-repeat: no-repeat;
    background-position: left 72.46% top -44.57%;
    background-size: 8.88% 174.38%;
    opacity: 0.42;
    pointer-events: none;
  }

  div.text-content {
    position: relative;
    z-index: 1;
    flex: 1 1 auto;
    min-width: 0;
    color: #000;

    .message {
      font-family: 'Din', sans-serif;
      font-size: 22px;
      font-weight: 700;
      line-height: 1;
      margin: 0;
    }

    small.timestamp {
      margin-top: 10px;
      color: #374151;
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      line-height: 1;
    }
  }

  div.btn-container {
    position: relative;
    z-index: 1;
    flex: 0 0 auto;

    .c-button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin: 0;
      padding: 16px 30px;
      border: 0;
      border-radius: 10px;
      color: #fff !important;
      background: var(--Gold-Gradient-01);
      box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
      font-family: 'Din', sans-serif;
      font-size: 30px;
      font-weight: 700;
      line-height: 1;
      text-transform: uppercase;

      img {
        width: 13px;
        height: 24px;
      }
    }
  }

  ${SIZES.mobile} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    min-height: 0;
    padding: 12px;
    background-image: url(${notificationWorld}), linear-gradient(92.6401deg, #fff 39.792%, #ffeebd 114.59%);
    background-position: right 0 bottom -2.63%, center;
    background-size: 58.38% 72.1%, cover;

    &::after {
      background-position: right 3.63% bottom -12.97%;
      background-size: 41.61% 88.37%;
    }

    div.text-content {
      width: 100%;

      .message {
        font-size: 18px;
        line-height: 1;
      }

      small.timestamp {
        margin-top: 10px;
        color: #6b7280;
        font-family: 'Din', sans-serif;
        font-size: 15px;
      }
    }

    div.btn-container .c-button {
      gap: 4px;
      padding: 16px 30px;
      font-size: 18px;

      img {
        width: 8px;
        height: 15px;
      }
    }
  }
`
export default function NotificationModal({ showModal, hideModal }) {
  const [values, loading, error] = useListVals(NotificationDb)
  const history = useHistory()
  const [notification, setNotification] = useState(null)

  const refreshPage = () => {
    window.location.reload()
  }
  
  const handleRedirect = (url) => {
    hideModal()
    history.push(url)
  }

  useEffect(() => {
    const newItems = values.length - localStorage.getItem('IA_notifications')
    let updated = values.sort((a,b)=> new Date(b.datetime) - new Date(a.datetime)).map((item,index) => {
      return {
        ...item,
        read: index < newItems ? false : true
      }
    })
    setNotification(updated)
    if (values.length > localStorage.getItem('IA_notifications')) {
      localStorage.setItem('IA_notifications', values.length)
    }
  }, [loading, values])

  return (
    <StyledModal
      show={showModal}
      onHide={hideModal}
      aria-labelledby="notification-modal"
    >
      <button className="desktop-close-modal" type="button" onClick={hideModal} aria-label="Close notifications">
        <img src={chevronRightIcon} alt="" aria-hidden="true" />
      </button>
      <Modal.Header>
        <Modal.Title>NOTIFICATIONS</Modal.Title>
        <button className="mobile-modal-close" type="button" onClick={hideModal} aria-label="Close notifications">
          <img src={closeCircleIcon} alt="" aria-hidden="true" />
        </button>
      </Modal.Header>
      <div className="desktop-notification-banner" aria-hidden="true" />
      <h2 className="desktop-modal-title">Notifications</h2>
      <Modal.Body>
        <section className="notification-list">
          {loading ? (
            <Loader />
          ) : error ? (
            <button id="refresh-btn" type="button" onClick={refreshPage}>
              Connection failed. Click here to refresh.
            </button>
          ) : (
            notification?.map((item, index) => (
              <MessageWrapper key={`notify-${index}`}>
                <div className="text-content">
                  <p className="message">{item.message}</p>
                  <small className="d-block timestamp">{item.datetime && <ReactTimeAgo date={item.datetime} />}</small>
                </div>
                {item.url && (
                  <div className="btn-container">
                    <button type="button" onClick={() => handleRedirect(item.url)} className="btn c-button">
                      <span>Enter</span>
                      <img src={chevronRightIcon} alt="" aria-hidden="true" />
                    </button>
                  </div>
                )}
              </MessageWrapper>
            ))
          )}
        </section>
      </Modal.Body>
    </StyledModal>
  )
}
